import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import _cloneDeep from 'lodash/cloneDeep'
import _findIndex from 'lodash/findIndex'
import _get from 'lodash/get'
import {useSelector} from 'react-redux'

export const getSingerMissionList = createAsyncThunk(
  'SongRoomTask/getSingerMissionList',
  async (p, store: any) => {
    const resp = await http.post('/live/song/singer_mission_center_detail', {
      ...store.getState().env.deviceinfo,
    })
    return resp.data.data
  }
)
export const getSongGodsRankList = createAsyncThunk(
  'SongRoomTask/getSongGodsRankList',
  async (p: any, store: any) => {
    const resp = await http.post('/live/song/song_gods_rank', {
      ...store.getState().env.deviceinfo,
      ...p,
    })
    return resp.data.data
  }
)

const initialState: {
  singerInfo: any
  missions: Array<any>
  scoreList: Array<any>
  myScore: any
  levelList: Array<any>
  myLevel: any
  starList: Array<any>
  myStar: any
  singerLevelCardList: Array<any>
  initialActiveIndex: number
} = {
  singerInfo: {},
  missions: [],
  scoreList: [],
  myScore: {},
  levelList: [],
  myLevel: {},
  starList: [],
  myStar: {},
  singerLevelCardList: [],
  initialActiveIndex: 0,
}

export const SongRoomTask = createSlice({
  name: 'SongRoomTaskCenter',
  initialState,
  reducers: {
    follow: (state, action) => {
      const {levelList} = state
      const {idx} = action.payload
      levelList[idx].followStatus = 1
      Object.assign(state, {
        levelList,
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getSingerMissionList.fulfilled, (state, action) => {
      const {singer_level, daily_mission_activity, singer_level_card_list} =
        action.payload
      const idx = _findIndex(
        singer_level_card_list,
        (item: any) => item.tier === singer_level.tier
      )
      const data = _cloneDeep(singer_level_card_list)
      if (idx !== -1) {
        data[idx] = {
          ...singer_level_card_list[idx],
          name: singer_level.name,
          avatar: singer_level.avatar,
          next_level_stars: singer_level.next_level_stars,
          curStars: singer_level.stars,
          curUserCard: true,
        }
      }
      Object.assign(state, {
        singerInfo: singer_level,
        missions: _get(daily_mission_activity, 'list', []),
        singerLevelCardList: data,
        initialActiveIndex: idx,
      })
    })
    builder.addCase(getSongGodsRankList.fulfilled, (state, action) => {
      const {
        score_rank_list,
        my_score_rank,
        level_rank_list,
        my_level_rank,
        star_rank_list,
        my_star_rank,
      } = action.payload
      Object.assign(state, {
        scoreList: score_rank_list || [],
        myScore: my_score_rank || {},
        levelList: level_rank_list || [],
        myLevel: my_level_rank || {},
        starList: star_rank_list || [],
        myStar: my_star_rank || {},
      })
    })
  },
})
export default SongRoomTask.reducer
export const SongRoomTaskActions = SongRoomTask.actions
